module.exports = __webpack_public_path__ + "static/img/home_service_center2.9de8197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_service_center2.png
// module id = ZNKU
// module chunks = 78